<template>
  <div>
    <h3>Attributes:</h3>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="value" label="参数" width="100"> </el-table-column>
      <el-table-column prop="describe" label="说明" width="350"> </el-table-column>
      <el-table-column prop="type" label="类型" width="200"> </el-table-column>
      <el-table-column prop="Option" label="可选值" width="300"> </el-table-column>
      <el-table-column prop="default" label="默认值" width="150"> </el-table-column>
      <el-table-column prop="required" label="必填" width="50"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          value: " color",
          describe: "颜色",
          type: "String",
          Option: "-",
          default: "-",
          required: "true"
        },
        {
          value: " themeKey",
          describe: "主题色关键字",
          type: "String",
          Option: "bigScreen/portal",
          default: "bigScreen",
          required: "false"
        }
      ]
    }
  }
}
</script>

<style>
</style>